import React from 'react';
import styled from 'styled-components';
import { StyledButtonProps } from '@contracts';
import Colors from './Colors';
import { ButtonStyleTemplate } from './SharedStyles';
import Spinner from './Spinner';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  size?: 'small' | 'normal' | 'large';
  children: React.ReactNode;
  buttonTextColor?: string;
  backgroundColor?: string;
  borderRadius?: string;
  isInline?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  loading = false,
  size = 'normal',
  type = 'button',
  buttonTextColor,
  backgroundColor,
  borderRadius,
  isInline,
  children,
  ...props
}) => (
  <ButtonStyle
    type={type}
    $size={size}
    $buttonTextColor={buttonTextColor}
    $backgroundColor={backgroundColor}
    $borderRadius={borderRadius}
    $isInline={isInline}
    {...props}
  >
    {loading ? <Spinner /> : children}
  </ButtonStyle>
);

export default Button;

const ButtonStyle = styled.button<StyledButtonProps>`
  ${ButtonStyleTemplate}

  &[disabled],
  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;

export const ButtonSecondary = styled(Button)`
  background: ${Colors.paleGold};
  color: ${Colors.forestGreen};
`;
